import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import {
  Button,
  Col,
  DatePicker,
  Form,
  message,
  Row,
  Tooltip,
  Modal,
} from "antd";
import { ReactComponent as VectorIcon } from "../../../assets/icons/Vector.svg";
import { ReactComponent as PlusIcon } from "../../../assets/icons/plusicon.svg";
import { Radio } from "antd";
import { Select } from "antd";
import { Input } from "antd";
import Table, { StyledTable } from "atoms/Table";
import moment from "moment";
import { getUserList, getHigherOfficials } from "redux/selectors";
import { getEmailsByRole } from "utils/functions";
import { connect, useSelector } from "react-redux";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { ReactComponent as TrashDelete } from "assets/Trash_Full.svg";
const { TextArea } = Input;
const { Option } = Select;

const ContainerOne = styled.div`
  .next_appraisal_period_for_the {
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 20.83px;
    text-align: left;
  }

  .next_appraisal_period {
    font-family: sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 18.23px;
    text-align: left;
    text-decoration-skip-ink: none;
    color: #636980;
  }
  .plusicon_btn_container {
    margin: 20px 0px 0px 0px;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .ant-radio-inner {
    background-color: white;
    border: 2px solid rgb(0, 218, 136) !important;
  }
  .ant-radio-checked .ant-radio-inner {
    background-color: rgb(0, 218, 136);
    border: 2px solid rgb(0, 218, 136) !important;
  }
  .ant-radio-inner::after {
    background-color: white;
    border: 2px solid rgb(0, 218, 136) !important;
  }
  .ant-radio-checked .ant-radio-inner::after {
    background-color: white !important;
    border: 2px solid rgb(0, 218, 136) !important;
  }
  .no_background_radio {
    margin: 0px 3px 0px 5px;
  }
  .no_background_radio .ant-radio-inner {
    background-color: white;
    border: 1px solid rgb(185, 185, 185) !important;
    outline: none !important;
  }
  .no_background_radio .ant-radio-inner {
    background-color: transparent !important;
    border: 1px solid gray !important;
  }
  .no_background_radio .ant-radio-inner::after {
    display: none !important;
    border: none !important;
  }
  .no_background_radio.ant-radio-checked .ant-radio-inner::after {
    background-color: white !important;
    border: none !important;
  }
  .no_background_radio .ant-radio-wrapper:hover .ant-radio,
  .ant-radio-input:focus + .ant-radio {
    box-shadow: none;
    outline: none;
  }
  .recommendations_regarding_appraisees {
    font-family: sans-serif;
    font-size: 13px;
    font-weight: 600;
    line-height: 20.83px;
    text-align: left;
    color: #1f243b;
  }

  .recommendations_container {
    margin: 40px 0px 0px 0px;
  }
  .custom_select_dropdown {
    width: 100%;
  }
  .custom_select_dropdown {
    margin: 5px 0px 25px 0px;
  }
  .textarea_dropdown_container {
    margin: 5px 0px 25px 0px;
  }
  .container_for_forms_new {
    margin: 30px 0px 20px 0px;
    background-color: rgb(248, 248, 248);
    border-radius: 20px;
    padding: 14px 15px 14px 15px;
  }
  .who_will_succeed {
    font-family: sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 18.23px;
    text-align: left;
    margin: 8px 8px 0px 0px;
    color: #1f243b;
  }
  .main_container_item {
    display: flex;
    width: 100%;
    border-radius: 25px;
    padding: 18px 15px 8px 15px;
  }
  .container_1 {
    width: 50%;
    margin: 25px 0px 0px 0px;
  }
  .container_2 {
    width: 50%;
    margin: 25px 0px 0px 0px;
  }
  .appraisal_container {
    display: flex;
    width: 100%;
  }
  .appraisal_name_ {
    width: 30%;
  }
  .appraisal_name_James {
    width: 70%;
  }
  .comment_container {
    margin: 20px 0px 20px 0px;
    padding: 18px 15px 10px 15px;
    border-radius: 16px;
    background-color: rgb(248, 248, 248);
  }
  .comment_title {
    font-family: sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 18.23px;
    text-align: left;
    color: #636980;
  }
  .comment_text {
    font-family: Sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
    color: #1f243b;
  }
`;

const Wrap = styled.div`
  .ant-input {
    border: none;
    background: none;
  }
`;
const RadioTableWrap = styled.div`
  .ant-radio-wrapper {
    flex: 1;
    text-align: center;
  }

  .ant-radio-group {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }

  .ant-table-tbody > tr > td {
    border: none;
    padding: 12px 8px;
  }

  .ant-radio-inner {
    border-color: #06c78e; /* Match the green color */
  }

  .ant-radio-checked .ant-radio-inner {
    background-color: #06c78e;
  }
`;

const NextAppraisal = ({
  userList,
  selectedSegment,
  appraisalDetails,
  nextAppraisalSubmit,
  appraisarGrowthValidationErrors,
  setAppraisarGrowthValidationErrors,
  roletype,
  tabId,
  setTabId,
  loading,
  rolledOverData,
  setRolledoverData,
  validationRollOverErrors,
  setValidationRoleOverErrors,
  appraiseeGrowthData,
  setAppraiseeGrowthData,
  formValues,
  setFormValues,
  isEdit,
  isView,
  draftLoading,
  appraisalRecord,
  userInfo,
  successionOnly,
  hideSuccession,
}) => {
  const [form] = Form.useForm();
  const history = useHistory();
  const { confirm } = Modal;
  const higherOfficialsList = useSelector(getHigherOfficials);
  const CEO = getEmailsByRole(higherOfficialsList, "CEO");
  const options = [
    { label: "None", value: "none" },
    { label: "Choose People", value: "choose" },
  ];

  // Sync formValues into Ant Design form fields whenever formValues loads/changes
  // (initialValues only works on first render; this handles async data)
  useEffect(() => {
    if (formValues?.[0]) {
      form.setFieldsValue({
        appraiserremark: formValues[0]?.appraiserremark,
        appraiserremarknext: formValues[0]?.appraiserremarknext,
        appraisercomment: formValues[0]?.appraisercomment,
      });
    }
  }, [formValues, form]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    // form.submit();
    // setIsModalVisible(false);
  };


  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const nextAppraisalValidation = () => {
    const errors = {};
    let isValid = true;

    rolledOverData.forEach((record) => {
      const { id, targetobjectives, expectedoutcomes, targetdate, weightage } =
        record;
      if (!errors[id]) errors[id] = {};

      if (!targetobjectives) {
        errors[id].targetobjectives = true;
        isValid = false;
      }

      if (!expectedoutcomes) {
        errors[id].expectedoutcomes = true;
        isValid = false;
      }

      if (!targetdate) {
        errors[id].targetdate = true;
        isValid = false;
      }

      if (!weightage) {
        errors[id].weightage = true;
        isValid = false;
      }
    });

    setValidationRoleOverErrors(errors);

    if (!isValid) {
      message.error(
        "Please fill all required fields in rolled-over objectives."
      );
    }

    return isValid;
  };

  const [weightageStrategicError, setWeightageStrategicError] = useState("");

  const nextAppraisalHandleChange = (value, record, field) => {
    const updatedData = rolledOverData.map((item) =>
      item.id === record.id ? { ...item, [field]: value } : item
    );
    setRolledoverData(updatedData);

    if (field === "weightage") {
      const total = updatedData.reduce(
        (sum, item) => sum + (parseFloat(item.weightage) || 0),
        0
      );

      setWeightageStrategicError(
        total !== 100 ? "Total weightage must be exactly 100%" : ""
      );
    }

    // Clear validation error for this field
    const updatedErrors = { ...validationRollOverErrors };
    const fieldErrors = updatedErrors?.[record.id];

    if (fieldErrors?.[field]) {
      delete fieldErrors[field];
      if (Object.keys(fieldErrors).length === 0) {
        delete updatedErrors[record.id];
      }
      setValidationRoleOverErrors(updatedErrors);
    }
  };

  const nextAppraisalAddRow = () => {
    if (rolledOverData.length >= 10) {
      message.warning("Maximum 10 rows allowed.");
      return;
    }

    const newRow = {
      id: rolledOverData?.length + 1, // unique ID
      targetobjectives: "",
      expectedoutcomes: "",
      targetdate: "",
      weightage: "",
    };

    setRolledoverData([...rolledOverData, newRow]);
  };

  const handleDeleteNextAppraisalRow = (id) => {
    // Remove the row from data
    const updatedData = rolledOverData.filter((item) => item.id !== id);
    setRolledoverData(updatedData);

    // Remove associated validation errors if any
    const updatedErrors = { ...validationRollOverErrors };
    if (updatedErrors[id]) {
      delete updatedErrors[id];
      setValidationRoleOverErrors(updatedErrors);
    }
    setWeightageStrategicError("");
  };

  const columns = [
    {
      title: "S.No",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Target Objectives Given for Upcoming Appraisal",
      dataIndex: "targetobjectives",
      key: "targetobjectives",
      width: "30%",
      render: (text, record, index) => (
        <>
          <Input.TextArea
            autoSize={{ minRows: 1, maxRows: 6 }}
            placeholder="Enter objectives..."
            value={record.targetobjectives}
            disabled={
              appraisalRecord?.contractstatus === "reviewed" ||
              (appraisalRecord?.contractid !== selectedSegment &&
              userInfo?.userid !== CEO)
            }
            onChange={(event) =>
              nextAppraisalHandleChange(
                event.target.value,
                record,
                "targetobjectives"
              )
            }
            style={{
              width: "100%",
              border: validationRollOverErrors?.[record.id]?.targetobjectives
                ? "1px solid red"
                : undefined,
            }}
          />
        </>
      ),
    },
    {
      title: "Expected Outcomes",
      dataIndex: "expectedoutcomes",
      key: "expectedoutcomes",
      width: "30%",
      render: (text, record) => (
        <Input.TextArea
          autoSize={{ minRows: 1, maxRows: 6 }}
          placeholder="Enter expected outcomes..."
          value={record.expectedoutcomes}
          disabled={
            appraisalRecord?.contractstatus === "reviewed" ||
            (appraisalRecord?.contractid !== selectedSegment &&
            userInfo?.userid !== CEO)
          }
          onChange={(event) =>
            nextAppraisalHandleChange(
              event.target.value,
              record,
              "expectedoutcomes"
            )
          }
          style={{
            width: "100%",
            border: validationRollOverErrors?.[record.id]?.expectedoutcomes
              ? "1px solid red"
              : undefined,
          }}
        />
      ),
    },
    {
      title: "Target Date",
      dataIndex: "targetdate",
      key: "targetdate",
      width: "40%",
      render: (text, record) => (
        <DatePicker
          placeholder="Enter target date..."
          value={
            record.targetdate ? moment(record.targetdate, "DD-MM-YYYY") : null
          }
          disabled={
            appraisalRecord?.contractstatus === "reviewed" ||
            (appraisalRecord?.contractid !== selectedSegment &&
            userInfo?.userid !== CEO)
          }
          onChange={(date, dateString) =>
            nextAppraisalHandleChange(dateString, record, "targetdate")
          }
          style={{
            border: validationRollOverErrors?.[record.id]?.targetdate
              ? "1px solid red"
              : undefined,
          }}
          format="DD-MM-YYYY"
        />
      ),
    },
    {
      title: "Weightage",
      dataIndex: "weightage",
      key: "weightage",
      render: (text, record) => (
        <Input
          placeholder="Enter challenges..."
          value={record.weightage}
          onChange={(e) =>
            nextAppraisalHandleChange(e.target.value, record, "weightage")
          }
          disabled={
            appraisalRecord?.contractstatus === "reviewed" ||
            (appraisalRecord?.contractid !== selectedSegment &&
            userInfo?.userid !== CEO)
          }
          maxLength={80}
          style={{
            border: validationRollOverErrors?.[record.id]?.weightage
              ? "1px solid red"
              : undefined,
          }}
        />
      ),
    },

    {
      title: "Action",
      key: "action",
      render: (text, record, index) => (
        <Button disabled={appraisalRecord?.contractstatus === "reviewed"}>
          <TrashDelete onClick={() => appraisalRecord?.contractstatus !== "reviewed" && handleDeleteNextAppraisalRow(record.id)}>
            Delete
          </TrashDelete>
        </Button>
      ),
    },
  ];

  const AppraisarGrowthHandleChange = (value, record, field, type) => {
    const updatedData = appraiseeGrowthData.map((item) => {
      if (item.id === record.id) {
        if (type === "radio") {
          return {
            ...item,
            low: field === "low" ? value : false,
            moderate: field === "moderate" ? value : false,
            high: field === "high" ? value : false,
          };
        } else {
          return {
            ...item,
            [field]: value,
          };
        }
      }
      return item;
    });

    setAppraiseeGrowthData(updatedData);

    // Clear validation errors on change
    const updatedErrors = { ...appraisarGrowthValidationErrors };
    if (updatedErrors?.[record.id]) {
      delete updatedErrors[record.id];
      setAppraisarGrowthValidationErrors(updatedErrors);
    }
  };

  const appraisarGrowthValidation = () => {
    const newErrors = {};

    appraiseeGrowthData.forEach((item) => {
      const noOptionSelected = !item.low && !item.moderate && !item.high;
      const noRemarks = !item.remarks?.trim();

      if (noOptionSelected || noRemarks) {
        newErrors[item.id] = {
          ...(noOptionSelected && { option: true }),
          ...(noRemarks && { remarks: true }),
        };
      }
    });

    setAppraisarGrowthValidationErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      message.error("Please fill all required fields in appraisee growth.");
      return false;
    }

    return true;
  };

  const AppraiseeGrowthColumns = [
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Low / None",
      dataIndex: "low",
      key: "low",
      render: (text, record) => (
        <>
          <Radio
            checked={text}
            disabled={
              appraisalRecord?.contractid !== selectedSegment &&
              userInfo?.userid !== CEO
            }
            onChange={(e) =>
              AppraisarGrowthHandleChange(
                e.target.checked,
                record,
                "low",
                "radio"
              )
            }
            style={{
              outline: appraisarGrowthValidationErrors?.[record.id]?.option
                ? "1px solid red"
                : undefined,
            }}
          />{" "}
          {record?.options?.[0]}
        </>
      ),
    },
    {
      title: "Moderate",
      dataIndex: "moderate",
      key: "moderate",
      render: (text, record) => (
        <>
          <Radio
            checked={text}
            disabled={
              appraisalRecord?.contractid !== selectedSegment &&
              userInfo?.userid !== CEO
            }
            onChange={(e) =>
              AppraisarGrowthHandleChange(
                e.target.checked,
                record,
                "moderate",
                "radio"
              )
            }
            style={{
              outline: appraisarGrowthValidationErrors?.[record.id]?.option
                ? "1px solid red"
                : undefined,
            }}
          />{" "}
          {record?.options?.[1]}
        </>
      ),
    },
    {
      title: "High",
      dataIndex: "high",
      key: "high",
      render: (text, record) => (
        <>
          <Radio
            checked={text}
            disabled={
              appraisalRecord?.contractid !== selectedSegment &&
              userInfo?.userid !== CEO
            }
            onChange={(e) =>
              AppraisarGrowthHandleChange(
                e.target.checked,
                record,
                "high",
                "radio"
              )
            }
            style={{
              outline: appraisarGrowthValidationErrors?.[record.id]?.option
                ? "1px solid red"
                : undefined,
            }}
          />{" "}
          {record?.options?.[2]}
        </>
      ),
    },
    {
      title: "Enter Remarks",
      dataIndex: "remarks",
      key: "remarks",
      render: (text, record) => (
        <Input
          placeholder="Enter Remarks..."
          value={record.remarks}
          onChange={(e) =>
            AppraisarGrowthHandleChange(e.target.value, record, "remarks")
          }
          disabled={
            appraisalRecord?.contractid !== selectedSegment &&
            userInfo?.userid !== CEO
          }
          style={{
            border: appraisarGrowthValidationErrors?.[record.id]?.remarks
              ? "1px solid red"
              : undefined,
          }}
        />
      ),
    },
  ];

  // const AppraiseeGrowthColumns = [
  //   {
  //     title: "Career Changes",
  //     dataIndex: "category",
  //     key: "category",
  //   },
  //   {
  //     title: "Demotion/ Transfer",
  //     dataIndex: "low",
  //     key: "low",
  //     render: (text, record) => (
  //       <>
  //         <Tooltip title="Details about career changes">
  //           <Radio
  //             checked={text}
  //             onChange={(e) =>
  //               AppraisarGrowthHandleChange(
  //                 e.target.checked,
  //                 record,
  //                 "low",
  //                 "radio"
  //               )
  //             }
  //           />
  //         </Tooltip>
  //         {record?.options[0]}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Retention in same job grade",
  //     dataIndex: "moderate",
  //     key: "moderate",
  //     render: (text, record) => (
  //       <>
  //         <Tooltip title="Details about career changes">
  //           <Radio
  //             checked={text}
  //             onChange={(e) =>
  //               AppraisarGrowthHandleChange(
  //                 e.target.checked,
  //                 record,
  //                 "moderate",
  //                 "radio"
  //               )
  //             }
  //           />
  //         </Tooltip>
  //         {record?.options[1]}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Promotion (to a higher job grade)",
  //     dataIndex: "high",
  //     key: "high",
  //     render: (text, record) => (
  //       <>
  //         <Tooltip title="Details about career changes">
  //           <Radio
  //             checked={text}
  //             disabled={
  //               primaryAppraiser && !roleTypes.includes(selectedSegment)
  //             }
  //             onChange={(e) =>
  //               AppraisarGrowthHandleChange(
  //                 e.target.checked,
  //                 record,
  //                 "high",
  //                 "radio"
  //               )
  //             }
  //           />
  //         </Tooltip>
  //         {record?.options[2]}
  //       </>
  //     ),
  //   },
  //   {
  //     title: "Enter Remarks",
  //     dataIndex: "remarks",
  //     key: "remarks",
  //     render: (text, record) => (
  //       <Input
  //         placeholder="Enter Remarks..."
  //         disabled={primaryAppraiser && !roleTypes.includes(selectedSegment)}
  //         value={record.remarks}
  //         onChange={(e) =>
  //           AppraisarGrowthHandleChange(e.target.value, record, "remarks")
  //         }
  //         style={{
  //           border: appraisarGrowthValidationErrors?.[
  //             appraisalInformation?.[appraisalIndex - 1]?.roletype
  //           ]?.[record.id]?.remarks
  //             ? "1px solid red"
  //             : "",
  //         }}
  //       />
  //     ),
  //   },
  // ];

  const footerStyle = {
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: "#fff",
    padding: "10px",
    display: "flex",
    justifyContent: "end",
    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
    margin: "-30px -20px",
  };


  // ── Step 1 (successionOnly): render ONLY the Succession Planning block ──
  if (successionOnly) {
    if (appraisalDetails?.appraiseeroletype !== "Primary") return null;
    return (
      <ContainerOne>
        <Form
          form={form}
          layout="vertical"
          onFinish={() => {
            nextAppraisalSubmit(formValues, "reviewed");
          }}
          onValuesChange={(_, values) => {
            setFormValues([
              {
                ...formValues?.[0],
                appraiserremark: values?.appraiserremark,
                appraiserremarknext: values?.appraiserremarknext,
              },
            ]);
          }}
          initialValues={formValues?.[0]}
        >
          <div style={{ marginTop: "20px" }}>
            <Row className="mb-3">
              <b>Succession Planning</b>
            </Row>
            <Row
              style={{
                background: "#fafafa",
                padding: "15px",
                marginBottom: "15px",
                borderRadius: "8px",
              }}
              gutter={16}
            >
              <Col xs={24} md={12}>
                <b className="pb-2">Who am I mentoring for my role?</b>
                <Row gutter={8}>
                  <Col xs={24} md={6}>
                    <b className="comment_title mt-2">People</b>
                  </Col>
                  <Col xs={24} md={18} style={{ whiteSpace: "wrap", wordWrap: "break-word" }}>
                    {formValues?.[0]?.mentoringrole !== "none"
                      ? userList
                          ?.filter((val) =>
                            formValues?.[0]?.succeedperson?.includes(val?.userid)
                          )
                          ?.map((item) => item?.fullname)
                          ?.join(", ") || "-"
                      : "none"}
                  </Col>
                  {formValues?.[0]?.mentoringrole !== "none" && (
                    <>
                      <Col xs={24} md={6}>
                        <b className="comment_title">Remark</b>
                      </Col>
                      <Col xs={24} md={18} style={{ whiteSpace: "wrap", wordWrap: "break-word" }}>
                        {formValues?.[0]?.succeedpersonremark}
                      </Col>
                    </>
                  )}
                </Row>
              </Col>
              <Col xs={24} md={12}>
                {isView ? (
                  <div>
                    <b className="comment_title">Appraiser's Remark</b>
                    <p>{formValues?.[0]?.appraiserremark || "-"}</p>
                  </div>
                ) : (
                <Form.Item
                  name="appraiserremark"
                  label="Remark"
                  rules={[{ required: false, message: "Remark is required" }]}
                >
                  <TextArea
                    placeholder="Remark"
                    allowClear
                    className="textarea_dropdown_container"
                    disabled={
                      appraisalRecord?.contractid !== selectedSegment &&
                      userInfo?.userid !== CEO
                    }
                  />
                </Form.Item>
                )}
              </Col>
              <Col xs={24} md={12}>
                <b className="pb-2">Who is mentoring me for my next role?</b>
                <Row gutter={8}>
                  <Col xs={24} md={6}>
                    <b className="comment_title mt-2">People</b>
                  </Col>
                  <Col xs={24} md={18} style={{ whiteSpace: "wrap", wordWrap: "break-word" }}>
                    {formValues?.[0]?.mentoringnextrole !== "none"
                      ? userList
                          ?.filter((val) =>
                            formValues?.[0]?.succeedpersonnext?.includes(val?.userid)
                          )
                          ?.map((item) => item?.fullname)
                          ?.join(", ") || "-"
                      : "none"}
                  </Col>
                  {formValues?.[0]?.mentoringnextrole !== "none" && (
                    <>
                      <Col xs={24} md={6}>
                        <b className="comment_title">Remark</b>
                      </Col>
                      <Col xs={24} md={18} style={{ whiteSpace: "wrap", wordWrap: "break-word" }}>
                        {formValues?.[0]?.succeedpersonremarknext}
                      </Col>
                    </>
                  )}
                </Row>
              </Col>
              <Col xs={24} md={12}>
                {isView ? (
                  <div>
                    <b className="comment_title">Appraiser's Remark</b>
                    <p>{formValues?.[0]?.appraiserremarknext || "-"}</p>
                  </div>
                ) : (
                <Form.Item
                  name="appraiserremarknext"
                  label="Remark"
                  rules={[{ required: false, message: "Remark is required" }]}
                >
                  <TextArea
                    placeholder="Remark"
                    allowClear
                    className="textarea_dropdown_container"
                    disabled={
                      appraisalRecord?.contractid !== selectedSegment &&
                      userInfo?.userid !== CEO
                    }
                  />
                </Form.Item>
                )}
              </Col>
            </Row>
          </div>
          {!isView && !isEdit && (
            <div style={footerStyle}>
              <ButtonOutlined
                style={{ width: "130px", height: "35px" }}
                onClick={() => history.push(`/performancemanagement`)}
              >
                Cancel
              </ButtonOutlined>
              {appraisalRecord?.contractid === selectedSegment && (
                <ButtonFilled
                  style={{ width: "130px", height: "35px" }}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  Save Changes
                </ButtonFilled>
              )}
            </div>
          )}
        </Form>
      </ContainerOne>
    );
  }

  return (
    <div>
      {(isView ||
        appraisalRecord?.contractid === selectedSegment ||
        appraisalRecord?.contractstatus !== "reviewed") && (
        <div style={{ background: "#f8f8f8", borderRadius: "12px", padding: "20px", marginTop: "24px" }}>
          <ContainerOne>
            <div className="Recommendations_for_next_month">
              <p className="next_appraisal_period_for_the">
                Responsibilities that needs to be rolled over to the next
                appraisal period
              </p>
              <p className="next_appraisal_period">
                Describe specific Strategic Objectives, actions, training or
                other developmental activities to be undertaken by Appraisee
                during the next period. (if any)
              </p>
            </div>
          </ContainerOne>
          <ContainerOne>
            <Wrap>
              <StyledTable
                dataSource={rolledOverData}
                columns={columns}
                className="small_table"
                rowKey="id"
                pagination={false}
                footer={() => (
                  <div>
                    <Button
                      type="dashed"
                      onClick={nextAppraisalAddRow}
                      disabled={appraisalRecord?.contractstatus === "reviewed"}
                    >
                      + Add Another (Max 10 rows)
                    </Button>
                  </div>
                )}
              />
              {weightageStrategicError && (
                <div style={{ color: "red" }}>{weightageStrategicError}</div>
              )}
            </Wrap>
          </ContainerOne>
        </div>
      )}

      <ContainerOne>
        {appraisalDetails?.appraiseeroletype === "Primary" && (
          <>
            {(appraisalRecord?.contractid === selectedSegment ||
              appraisalRecord?.contractstatus !== "attended") && (
              <>
                  {!isView && (
                  <div style={{ background: "#f8f8f8", borderRadius: "12px", padding: "20px", marginTop: "24px" }}>
                    <p className="recommendations_regarding_appraisees" style={{ marginBottom: "12px" }}>
                      Recommendations regarding Appraisee's career growth. Choose
                      the appropriate.
                    </p>
                    <Table
                      dataSource={appraiseeGrowthData}
                      columns={AppraiseeGrowthColumns}
                      pagination={false}
                      bordered
                    />
                  </div>
                  )}
              </>
            )}
          </>
        )}

        <div>
          <Form
            form={form}
            key={roletype}
            name={roletype}
            layout="vertical"
            onFinish={(values) => {
              appraisalDetails?.appraiseeroletype === "Primary"
                ? !weightageStrategicError &&
                  nextAppraisalValidation() &&
                  appraisarGrowthValidation() &&
                  nextAppraisalSubmit(values, "reviewed")
                : !weightageStrategicError &&
                  nextAppraisalValidation() &&
                  nextAppraisalSubmit(values, "reviewed");
            }}
            onValuesChange={(changedValues) => {
              setFormValues([
                {
                  ...formValues?.[0],
                  ...changedValues,
                },
              ]);
            }}
            initialValues={formValues?.[0]}
          >
            {appraisalDetails?.appraiseeroletype === "Primary" && !hideSuccession && (
              <>
                <div style={{ background: "#f8f8f8", borderRadius: "12px", padding: "20px", marginTop: "24px" }}>
                  <Row className="mb-3">
                    <b>Succession Planning</b>
                  </Row>
                  <Row
                    style={{
                      padding: "15px",
                      marginBottom: "15px",
                    }}
                    gutter={16}
                  >
                    <Col xs={24} md={12}>
                      <b className="pb-2">Who am I mentoring for my role?</b>
                      <Row gutter={8}>
                        <Col xs={24} md={6}>
                          <b className="comment_title mt-2">People</b>
                        </Col>
                        <Col
                          xs={24}
                          md={18}
                          style={{ whiteSpace: "wrap", wordWrap: "break-word" }}
                        >
                          {formValues?.[0]?.mentoringrole !== "none"
                            ? userList
                                ?.filter((val) =>
                                  formValues?.[0]?.succeedperson?.includes(
                                    val?.userid
                                  )
                                )
                                ?.map((item) => item?.fullname)
                                ?.join(", ") || "-"
                            : "none"}
                        </Col>
                        {formValues?.[0]?.mentoringrole !== "none" && (
                          <>
                            <Col xs={24} md={6}>
                              <b className="comment_title">Remark</b>
                            </Col>
                            <Col
                              xs={24}
                              md={18}
                              style={{
                                whiteSpace: "wrap",
                                wordWrap: "break-word",
                              }}
                            >
                              {formValues?.[0]?.succeedpersonremark}
                            </Col>
                          </>
                        )}
                      </Row>
                      {/* <Form.Item name="mentoringrole">
                    <Radio.Group
                      options={options}
                      optionType="default"
                      disabled
                    />
                  </Form.Item> */}
                    </Col>
                    <Col xs={24} md={12}>
                      {isView ? (
                        <div>
                          <b className="comment_title">Appraiser's Remark</b>
                          <p>{formValues?.[0]?.appraiserremark || "-"}</p>
                        </div>
                      ) : (
                      <>
                        <Form.Item
                          name="appraiserremark"
                          label="Remark"
                          rules={[
                            {
                              required: false,
                              message: "Remark is required",
                            },
                          ]}
                        >
                          <TextArea
                            placeholder="Remark"
                            allowClear
                            className="textarea_dropdown_container"
                            disabled={
                              appraisalRecord?.contractid !== selectedSegment &&
                              userInfo?.userid !== CEO
                            }
                          />
                        </Form.Item>
                      </>
                      )}
                    </Col>
                    <Col xs={24} md={12}>
                      <b className="pb-2">
                        Who is mentoring me for my next role?
                      </b>
                      <Row gutter={8}>
                        <Col xs={24} md={6}>
                          <b className="comment_title mt-2">People</b>
                        </Col>
                        <Col
                          xs={24}
                          md={18}
                          style={{ whiteSpace: "wrap", wordWrap: "break-word" }}
                        >
                          {formValues?.[0]?.mentoringnextrole !== "none"
                            ? userList
                                ?.filter((val) =>
                                  formValues?.[0]?.succeedpersonnext?.includes(
                                    val?.userid
                                  )
                                )
                                ?.map((item) => item?.fullname)
                                ?.join(", ") || "-"
                            : "none"}
                        </Col>
                        {formValues?.[0]?.mentoringnextrole !== "none" && (
                          <>
                            <Col xs={24} md={6}>
                              <b className="comment_title">Remark</b>
                            </Col>
                            <Col
                              xs={24}
                              md={18}
                              style={{
                                whiteSpace: "wrap",
                                wordWrap: "break-word",
                              }}
                            >
                              {formValues?.[0]?.succeedpersonremarknext}
                            </Col>
                          </>
                        )}
                      </Row>
                    </Col>

                    <Col xs={24} md={12}>
                      {isView ? (
                        <div>
                          <b className="comment_title">Appraiser's Remark</b>
                          <p>{formValues?.[0]?.appraiserremarknext || "-"}</p>
                        </div>
                      ) : (
                      <>
                        <Form.Item
                          name="appraiserremarknext"
                          label="Remark"
                          rules={[
                            {
                              required: false,
                              message: "Remark is required",
                            },
                          ]}
                        >
                          <TextArea
                            placeholder="Remark"
                            allowClear
                            className="textarea_dropdown_container"
                            disabled={
                              appraisalRecord?.contractid !== selectedSegment &&
                              userInfo?.userid !== CEO
                            }
                          />
                        </Form.Item>
                      </>
                      )}
                    </Col>
                  </Row>
                </div>
              </>
            )}

            <ContainerOne style={{ background: "#f8f8f8", borderRadius: "12px", padding: "20px", marginTop: "24px", marginBottom: isView ? "160px" : "0px" }}>
              <Row gutter={16}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                  <b>Overall Rating / Comments</b>

                  <div class="main_container_item">
                    <div class="container_one container_1">
                      <div className="appraisal_container">
                        <p className="appraisal_name_">Appraisee Name</p>
                        <p className="appraisal_name_James">
                          {/* {appraisername || "-"} */}
                          {appraisalDetails?.employeename || "-"}
                        </p>
                      </div>
                      <div className="appraisal_container">
                        <p className="appraisal_name_">Submit Date</p>
                        <p className="appraisal_name_James">
                          {appraisalDetails?.attendedon
                            ? moment(appraisalDetails?.attendedon).format(
                                "DD-MM-YYYY"
                              )
                            : "-"}
                        </p>
                      </div>
                    </div>

                    <div class="container_two container_2">
                      <div className="appraisal_container">
                        <p className="appraisal_name_">Appraiser Name</p>
                        <p className="appraisal_name_James">
                          {userList?.find(
                            (val) =>
                              val?.userid === appraisalDetails?.appraisarmailid
                          )?.fullname || "-"}
                        </p>
                      </div>
                      <div className="appraisal_container">
                        <p className="appraisal_name_">Accepted Date</p>
                        <p className="appraisal_name_James">
                          {appraisalDetails?.attendedon &&
                          appraisalDetails?.attendedon
                            ? moment(
                                appraisalDetails.attendedon,
                                "YYYY-MM-DDTHH:mm:ssZ"
                              ).format("DD-MM-YYYY")
                            : "-"}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="comment_container">
                    <p class="comment_title">Appraisee’s Comment</p>
                    <p class="comment_text">
                      {appraisalDetails?.individualassessment?.[0]
                        ?.overallsummary || "-"}
                    </p>
                  </div>

                  <div class="comment_container">
                    {isView ? (
                      <>
                        <p class="comment_title">Appraiser’s Comment</p>
                        <p class="comment_text">
                          {formValues?.[0]?.appraisercomment || "-"}
                        </p>
                      </>
                    ) : (
                      <Form.Item
                        name="appraisercomment"
                        label="Appraiser’s Comment"
                        rules={[
                          {
                            required: true,
                            message: "Appraiser’s Comment is required",
                          },
                        ]}
                      >
                        <TextArea
                          placeholder="Appraiser’s Comment"
                          allowClear
                          className="textarea_dropdown_container"
                          disabled={
                            appraisalRecord?.contractid !== selectedSegment &&
                            userInfo?.userid !== CEO
                          }
                        />
                      </Form.Item>
                    )}
                  </div>
                </Col>
              </Row>
            </ContainerOne>
            {/* {appraisalDetails?.appraiseeroletype === "Primary" && ( */}
            {!isView && (
              <div style={footerStyle}>
                <ButtonOutlined
                  style={{ width: "130px", height: "35x" }}
                  onClick={() => history.push(`/performancemanagement`)}
                >
                  Cancel
                </ButtonOutlined>
                {/* {tabId === 2 && ( */}
                <>
                  {isEdit && tabId === 2 && (
                    <>
                      <ButtonOutlined
                        style={{ width: "130px", height: "35x" }}
                        onClick={() => {
                          setTabId(tabId - 1);
                        }}
                      >
                        Previous
                      </ButtonOutlined>
                    </>
                  )}
                  {isEdit && (
                    <ButtonFilled
                      style={{ width: "130px", height: "35x" }}
                      type="primary"
                      loading={draftLoading}
                      onClick={() => nextAppraisalSubmit(formValues, "draft")}
                    >
                      Save as Draft
                    </ButtonFilled>
                  )}
                  {appraisalRecord?.contractid === selectedSegment && (
                    <ButtonFilled
                      style={{ width: "130px", height: "35x" }}
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                    >
                      {isEdit ? "Close" : "Save Changes"}
                    </ButtonFilled>
                  )}
                </>
              </div>
            )}
          </Form>

          {/* {Object.keys(appraisarGrowthValidationErrors?.[roletype] || {})
            .length > 0 &&
            tableData[selectedSegment]?.some(
              (record) =>
                appraisarGrowthValidationErrors[roletype]?.[record.id]
                  ?.radioSelection
            ) && (
              <div
                style={{ color: "red", fontSize: "14px", marginTop: "10px" }}
              >
                Please select the option.
              </div>
            )} */}
        </div>
      </ContainerOne>
      <br />

      <Modal
        title="Confirmation"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>Are you sure you want to save the changes?</p>
      </Modal>
    </div>
  );
};
const mapStateToProps = (state) => ({
  userList: getUserList(state),
});

export default connect(mapStateToProps)(NextAppraisal);